import React from 'react'
import {
    Redirect
} from 'react-router-dom'
import {
  connect,
} from 'react-redux';
import { setAlertWarning, clearAlerts } from '../store/WriteClass';


class UserLoggedOutComponent extends React.Component {

  componentDidMount() {
    const { setAlertWarning, clearAlerts } = this.props
    setAlertWarning({
        message: 'Your session has expired. Please login again to resume',
        onDismiss: () => { clearAlerts() }
    })
  }

  render() {
    return ( <Redirect to={{ pathname: '/' }}/> )
  }
}

function mapStateToProps(state) {
  return {}
}

function mapDispatchToProps(dispatch) {
    return {
        setAlertWarning: (alert) => dispatch(setAlertWarning(alert)),
        clearAlerts: () => dispatch(clearAlerts()),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserLoggedOutComponent)


// WEBPACK FOOTER //
// ./src/components/UserLoggedOutComponent.js